import React from 'react'
import Techokids from '../../Assets/techokids.jfif'
import Kylo from '../../Assets/tech/kylo.jpeg'
import './experience.css'
function Experience() {
  return (
    <>
      <div>
        <div className="container">
          <div className="section-title">
            <h2>Experience</h2>
            <h3>that i have ,</h3>
          </div>
          <div className="row">
            <div className="col-sm-8">
              <div className="exp_content">
                <div className="row">
                  <div className="col-sm-4">
                    <img src={Kylo} />
                  </div>
                  <div className="col-sm-8">
                    <div className="exp_data">
                      <h2>Kylo Apps</h2>
                      <h4>Role : Backend Developer Intern</h4>
                      <h4>Job description</h4>
                      <p>
                        I am working on various projects . Some are from scratch
                        amd some from middle. My work is to make design database
                        scheama , bussiness logic of the Mobile/ Web application
                        and creating RESTAPI in EXPRESS , NODEJS , SQL / NOSQL .
                        <br></br>
                        <strong>Projects</strong>
                        <ul>
                          <li>Employee Data Managment </li>
                          <li>Investor Portfolio </li>
                          <li>Agriculter Auction Managment System </li>
                          <li>Online Course Providing Application </li>
                          <li>Fundraiser Application </li>
                        </ul>
                        <strong>Learnings</strong>
                        <ul>
                          <li>Authentication & AUthorization </li>
                          <li>
                            Payment Gatway Integration Paytm , Razorpay &
                            CCavenue
                          </li>
                          <li>Schema Design </li>
                          <li>API Optimization and many more...</li>
                        </ul>
                      </p>

                      <h4>
                        Certificate : <a href="">Here</a>
                      </h4>
                      <h4>
                        LOR :<a href="">Here</a>{' '}
                      </h4>
                      <h4>Duration : August 2021 to OnGoing</h4>
                      <a href="https://kyloapps.com/">Kylo Apps</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4"></div>
          </div>
          <br></br>
          <div className="row">
            <div className="col-sm-8">
              <div className="exp_content">
                <div className="row">
                  <div className="col-sm-4">
                    <img src={Techokids} />
                  </div>
                  <div className="col-sm-8">
                    <div className="exp_data">
                      <h2>Techokids Private Limited</h2>
                      <h4>Role : Backend Developer Intern</h4>
                      <h4>Job description</h4>
                      <p>
                        My work was to create a RESTAPI and connect them with
                        the FrontEnd .I was working on 3 projects ( Student
                        dashboard , Teacher dashboard , Admin dashboard ). I
                        learn lot of things during Internship.
                        <br></br>
                        <strong>Projects</strong>
                        <ul>
                          <li>Online One to One Coding classes Application </li>
                          <li>Student dashboard </li>
                          <li>Teacher dashboard </li>
                          <li>Admin dashboard </li>
                        </ul>
                      </p>

                      <h4>
                        Certificate :{' '}
                        <a href="https://drive.google.com/file/d/15Us5PUrAcvrZ9qZbRXraWRDaIfIGvbyi/view?usp=sharing">
                          Here
                        </a>
                      </h4>
                      <h4>
                        LOR :
                        <a href="https://drive.google.com/file/d/15Zeb6EVMnOWvoJmMkcLDZW8zGtZJVhwB/view?usp=sharing">
                          Here
                        </a>{' '}
                      </h4>
                      <h4>Duration : March to April 2021 </h4>
                      <a href="https://www.techokids.com/">
                        Techokids Private Limited
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4"></div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Experience
